import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class UserPreferenceApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getUserPreference(): Observable<UserPreferenceResponseDAO> {
    const context = new HttpContext();
    return this.httpClient.get<UserPreferenceResponseDAO>(`${this.baseUrl}/user-preferences`, { context });
  }

  public saveUserPreference(payload: AiTaggingFlagDetails): Observable<UserPreferenceResponseDAO> {
    return this.httpClient.post<UserPreferenceResponseDAO>(`${this.baseUrl}/user-preferences`, payload);
  }
}
